import React from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import DataTable from "../table/DataTable";
import tableDataSelector from "../../selectors/selected_table_data";
import { updateData } from '../../actions';
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  alarmList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  }
});

class TableContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      config: {
        padding: "default",
        columns: [
          {
            key: "displayTimestamp",
            isNumeric: false,
            padding: "default",
            label: "Date"
          },
          {
            key: "value",
            isNumeric: false,
            padding: "default",
            label: "Status"
          }
        ],
        search: '',
        order: 'asc',
        orderBy: '',
        title: ''
      }
    };
  }

  setConfig = () => {
    const { title, columns, orderBy, order = 'desc', updateData, updatedData } = this.props;

    this.setState({
      config: {
        ...this.state.config,
        columns,
        title,
        orderBy,
        order,
      }
    }, () => updateData(updatedData));
  };

  componentDidMount() {
    this.setConfig();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { loading, title } = this.props;
    if ((prevProps.loading && !loading) || (prevProps.title !== title)) {
      this.setConfig();
    }
  }

  formatTableData = tableData => tableData.map(item => {
    if (item.values && item.values.length) {
      item.alarmValue = <List className="alarmList">
        {
          item.values.map(({ title, value }) => {
            return <li key={`alarmList-${title}`} className="alarmListItem">
                <span
                >{`${title} : ${value ? 'ON' : 'OFF'}`}</span>
            </li>
          })
        }
      </List>
    }
    return item;
  });

  render() {
    const { tableData } = this.props;
    const { config } = this.state;

    return <Grid item xs={12} md={9}>
      <div>
        <DataTable
          data={this.formatTableData(tableData)}
          config={config}
        />
      </div>
    </Grid>;
  }
}

TableContent.propTypes = {};

const mapStateToProps = (state) => {
  return {
    tableData: tableDataSelector(state),
  };
};

export default withStyles(styles)(
  connect(
    mapStateToProps,
    {
      updateData
    }
  )(TableContent)
);



// WEBPACK FOOTER //
// ./src/components/operationData/table-content.js